module.exports = __webpack_public_path__ + "static/Annalisa_Macaluso-cdea219f5ebcb2f5418eca65af23f8a1.jpg";